export const addChatMessage = (update) =>
    ({
        type    : 'ADD_CHAT_MESSAGE',
        payload : update
    });
export const setUnreadMsgCount = (count) => 
    ({
        type    : 'SET_UNREAD_MSG_COUNT',
        payload : { value: count }
    })